<template>
  <vs-popup :active.sync="isActive" :title="(theBill ? theBill.billNo : 'Yeni Sipariş') + 'Detay'" v-esc="escape" id="billReviewerPopup">
    <vs-popup class="holamundo" title="Fatura Sil" :active.sync="isDeleteActive" v-esc="escapeDelete">
      <vs-row vs-type="flex" vs-w="12">
        <p>Fatura, yapılan ödemeler ve buna bağlı giderler silenecek. Ayrıca ilgili kayıt edilen ilgili stok
          miktarları,alış fiyatları ve reçete maaliyetleri bir önceki faturaya göre düzenlenecektir. Bu işlemin geri
          dönüşü yoktur. Bu fatura yine de silinsin mi ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="isDeleteActive = false;deletedId = null">Vazgeç</vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteData(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <div class="con-example-prompt" v-if="theBill != null">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12" id="billHeader" vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="6" class="pl-5 py-5">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-align="center">
                <span class="text-primary bold h4">
                  {{theBill.branch.name}}
                </span>
                <vx-tooltip v-if="!isPrintMode" text="Yazdır" position="top">
                  <vs-button @click="printBill" color="primary" size="small" class="ml-2" icon-pack="feather"
                    icon="icon-printer" />
                </vx-tooltip>
                <vx-tooltip v-if="!theBill.isSolid && theBill.branch.id == $currentUser.branch.id" title="Faturayı Sil"
                  text="Faturayı, daha önce yapılan ödemeleri ve giderleri sil." position="top">
                  <vs-button @click="isDeleteActive = true;deletedId = theBill.id;" color="danger" size="small"
                    class="ml-2" icon-pack="feather" icon="icon-trash-2" />
                </vx-tooltip>
                 <vx-tooltip title="Excel Export"
                  position="top">
                  <vs-button @click="getExcelBill" color="primary" type="gradient" size="small"
                    class="ml-2" icon-pack="feather" icon="icon-download" />
                </vx-tooltip>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1" v-if="theBill.supplier != null">
                <span class="h5 w-full weight-600">
                  {{theBill.supplier.name + (theBill.distributor != null ? ' - ' + theBill.distributor.name : '')}}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <span class="h5 w-full">
                  {{theBill.created}}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5" class="mr-2" id="bill-logo-col" vs-justify="flex-end">
            <img :src= logo id="bill-logo" />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" id="billContent">
          <vs-list id="billReviewerPopupList">
            <vs-row vs-type="flex" vs-w="12" class="pt-4" id="billContentHeaderRow" vs-justify="space-between">
              <vs-col vs-type="flex" vs-w="9.5" vs-justify="flex-start">
                <span class="text-primary bold">
                  Stok Adı
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="2.5" vs-justify="flex-end">
                <span class="text-primary bold">
                  Fiyat
                </span>
              </vs-col>
            </vs-row>
            <vs-divider color="primary" class="px-5 m-0 my-1" />
            <vs-row id="billContentEntry" vs-type="flex" vs-w="12" vs-justify="space-between"
              v-for="(entry,index) in theBill.billEntries" :key="index">
              <vs-row vs-type="flex" vs-w="9.5" vs-justify="flex-start" class="px-6">
                <vs-list-item
                  :title="'• ' + '(' + entry.rawMaterial.stockCode + ')' + entry.rawMaterial.name + ' ' + entry.quantity + ' ' + entry.unit.name"
                  :subtitle="$toCurrency(entry.unitPrice, 2) + ' / ' + entry.unit.name + ' | ' + (entry.discount > 0 ? (entry.discount + entry.discountType + ' Kalem İskontosu | ') : '') + entry.rawMaterial.kdv + '% (' + $toCurrency(entry.kdvPrice, 2) + ') KDV | ' + (entry.distributor != null ? entry.distributor.name : '') " />
              </vs-row>
              <vs-row vs-type="flex" vs-w="2.5" vs-justify="flex-end" vs-align="center" class="pr-6">
                <span class="bold text-small">
                  {{($toCurrency(entry.unitPrice * entry.quantity, 2))}}
                </span>
              </vs-row>
            </vs-row>
            <div id="billContentFooter">
              <span class="text-xsmall">
                Fatura İskontosu :
              </span>
              <span class="text-xsmall weight-500 mr-2">
                {{$toCurrency(theBill.totalDiscount, 2) + theBill.totalDiscountType}}
              </span>
              <span class="text-xsmall">
                Kalem Sayısı :
              </span>
              <span class="text-xsmall weight-500">
                {{theBill.billEntries.length}}
              </span>
            </div>
          </vs-list>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6 py-4" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-w="6" v-if="theBill.status == 1 && theBill.branch.id == $currentUser.branch.id">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                <vs-col vs-type="block" vs-w="5">
                  <span class="text-primary block weight-500">
                    Ödeme Tipi
                  </span>
                  <v-select class="text-dark weight-600" name="Ödeme Tipi" v-model="newPayment.paymentMethod"
                    itemid="id" label="name" :options="paymentMethods" :clearable="false" />
                </vs-col>
                <vs-col vs-type="block" vs-w="6">
                  <span class="text-primary text-medium-small block weight-500">
                    Kalan Tutar
                  </span>
                  <span class="text-dark text-medium-small2 bold block" style="margin-top:-5px;">
                    {{$toCurrency(theBill.leftPrice, 2)}}
                  </span>
                </vs-col>

              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-2" v-if="theBill.branch.id == $currentUser.branch.id">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-col vs-type="block" vs-w="6">
                    <span class="text-primary block weight-500">
                      Ödenecek Tutar ₺
                    </span>
                    <vs-input id="billRevSavePrice" name="Ödeme Tutarı" size="small"
                      v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,max_value:theBill.id == 0 ? totalBuyPrice.toFixed(2) : theBill.leftPrice.toFixed(2)}"
                      v-model="newPayment.inputPrice" class="w-full text-primary" />
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="6" class="px-2" vs-align="flex-end">
                    <span class="text-danger text-xsmaller"
                      v-show="errors.has('Ödeme Tutarı')">{{ errors.first('Ödeme Tutarı')}}</span>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="block" vs-w="6" vs-align="center">
                  <span class="text-end block text-small text-primary weight-500">
                    Toplam Kdv
                  </span>
                  <span class="text-dark text-end text-small block bold">
                    {{$toCurrency(theBill.totalKdvPrice, 2)}}
                  </span>
                </vs-col>
                <vs-col vs-type="block" vs-w="6" vs-align="center">
                  <span class="block text-end text-medium-small text-primary weight-500">
                    Toplam Tutar
                  </span>
                  <span class="text-dark text-end block text-medium-small2 bold" style="margin-top:-5px;">
                    {{$toCurrency(theBill.totalPrice, 2)}}
                  </span>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="flex-end"
                v-if="theBill.status === 1">
                <vs-col vs-type="flex" vs-w="7" vs-justify="flex-end" vs-align="center" class="px-1">
                  <vs-button v-if="!isPrintMode" type="gradient" color="secondary"
                    @click="newPayment.inputPrice = theBill.leftPrice;submitPayment();" class="p-3"
                    :disabled="newPayment.inputPrice === theBill.leftPrice">
                    Hepsini Öde</vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end" vs-align="center" class="px-1">
                  <vs-button v-if="!isPrintMode" type="gradient" icon-pack="feather" icon="icon-save" color="success"
                    @click="submitPayment" :disabled="newPayment.inputPrice === 0 || theBill.status === 2">
                    Kaydet</vs-button>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
  import NewBillAdd from "./NewBillAdd.vue";
  import {
    submitPayment,
    deleteBill,
    getExcelBill
  } from "@/api/Bill.js";
import companyInfo from '../../../model/constants/companyInfo';
  export default {
    data() {
      return {
        deletedId: null,
        isDeleteActive: false,
        isPrintMode: false,
        isActive: false,
        theBill: null,
        logo:companyInfo.logo,
        paymentMethods: [{
            id: 1,
            name: "Nakit",
          },
          {
            id: 2,
            name: "Kredi Kartı"
          }
        ],
        newPayment: {
          paymentMethod: {
            id: 1,
            name: 'Nakit'
          },
          billId: 0,
          inputPrice: 0
        },
      }
    },
    components: {
      NewBillAdd
    },
    methods: {
      getExcelBill() {
        getExcelBill(this.theBill.id).then(res => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.theBill.billNo + ' Fatura Detayı.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      },
      deleteData(id) {
        deleteBill(id).then(res => {
          if (res && res.status === 200) {
            if (res.data === true) {
              this.$emit("deleteBill", id);
              this.isDeleteActive = false;
              this.isActive = false;
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Fatura Silme Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "warning",
                title: "Silme Başarısız !",
                text: "Bu faturayı silme yetkiniz bulunmamaktadır !"
              });
            }

          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Fatura Silme Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      escapeDelete() {
        if (this.isDeleteActive) {
          this.isDeleteActive = false;
          this.deletedId = null;
        }
      },
      printBill() {
        this.isPrintMode = true;
        this.$nextTick(() => {
          window.print();
          this.isPrintMode = false;
        });
      },
      escape() {
        if (this.isActive == true) this.isActive = false;
      },
      initValues() {
        this.theBill = null;
        this.newPayment = {
          paymentMethod: {
            id: 1,
            name: 'Nakit'
          },
          billId: 0,
          inputPrice: 0
        }
      },
      submitPayment: async function () {
        this.newPayment.inputPrice = parseFloat(this.newPayment.inputPrice.toFixed(2));
        let checker = await this.$validator.validateAll();
        if (!checker) return;
        submitPayment(this.newPayment).then(res => {
          if (res && res.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Ödeme Başarılı !"
            });
            this.$emit("reloadList")
            this.isActive = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata :" + res.status,
              text: "Ödeme Başarısız !"
            });
          }
        }).catch(error => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error
          });
        });
      }
    },
    watch: {
      isActive(val) {
        if (!val) this.initValues();
        else this.newPayment.billId = this.theBill.id;
      }
    },
    mounted() {
      this.newPayment.userId = this.$currentUser.id;
    }
  }

</script>

<style>
  #billReviewerPopup .vs-popup {
    width: 750px !important;
    color: #2B2B2B;
  }

  #billReviewerPopup .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    background: transparent linear-gradient(152deg, #F8F8F8 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;
  }

  #newBillTotalDiscountType,
  #entryDiscountType {
    min-width: 50px !important;
    background: rgba(var(--vs-primary), 1)
  }

  #bill-logo {
    filter: grayscale(100%);
    opacity: .08;
    height: 175%;
    margin-top: -18px;
  }

  #billHeader {
    height: 6rem;
    background: transparent linear-gradient(117deg, #F8F8F8 0%, #EFEFEF 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px;
  }

  #bill-logo-col {
    height: 100%;
    overflow: hidden;
  }

  #billContentHeaderRow {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  #billReviewerPopup .vs-popup .vs-popup--header {
    background: unset !important;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px 7px 0px 0px;
  }

  #billReviewerPopupList {
    height: 50vh;
    overflow-x: auto;
    box-shadow: 0px 2px 4px #00000026;
    border-radius: 7px;
  }

  #billContentEntry .vs-row .vs-list--item .list-titles .vs-list--subtitle {
    margin-left: 10px;
    font-weight: 500;
  }

  #billContentFooter {
    position: absolute;
    bottom: 0;
    right: 5%;
  }

  #billFooter .vs-inputx {
    border: none !important;
    border-bottom: 1px solid #00000035 !important;
    border-radius: 0;
    font-size: 12px;
  }

  #billFooter .vs__dropdown-toggle {
    border: none;
    border-bottom: 1px solid #00000035;
    border-radius: 0;
    font-size: 12px;
  }

</style>
